/**
 * GoldFire Network (https://goldfire.me)
 * Copyright (c) 2012 - 2020, GoldFire Studios, Inc.
 * http://goldfirestudios.com
 */

import {createApp} from './main';

// Create the app, router and store instances.
const {app, router, store} = (typeof window === 'undefined') ? {} : createApp();

// Export the created app.
export {app, router, store};
